var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicle11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382 468 c-24 -11 -42 -21 -39 -24 4 -5 97 34 97 41 0 8 -13 4 -58 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415 459 c-38 -16 -78 -28 -87 -25 -10 2 -15 -1 -12 -9 3 -7 0 -31 -6 -54 -14 -54 -38 -54 -46 -1 l-7 40 -53 0 c-51 0 -54 -1 -54 -25 0 -20 -5 -25 -25 -25 -14 0 -25 5 -25 10 0 6 -14 10 -31 10 -44 0 -69 -32 -69 -87 l0 -43 131 0 c71 0 149 5 173 11 40 10 45 15 66 67 12 31 34 67 48 79 l26 22 77 -74 c60 -59 80 -73 98 -68 17 4 19 8 10 19 -14 17 -23 18 -13 2 4 -7 3 -8 -4 -4 -6 4 -9 12 -7 19 2 7 -12 30 -32 52 -20 22 -30 31 -22 20 13 -18 13 -19 -3 -6 -10 7 -16 17 -13 21 6 10 -27 72 -40 77 -6 1 -41 -11 -80 -28z m89 -5 c3 -8 2 -12 -4 -9 -6 3 -10 10 -10 16 0 14 7 11 14 -7z m-167 -56 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-147 -33 c0 -14 -6 -25 -13 -25 -20 0 -25 9 -20 31 8 28 33 24 33 -6z m63 -7 c6 -40 6 -41 -27 -32 -21 5 -26 12 -26 35 0 24 4 29 24 29 19 0 25 -6 29 -32z m69 -20 c-6 -6 -7 0 -4 19 5 21 7 23 10 9 2 -10 0 -22 -6 -28z m259 15 c13 -16 12 -17 -3 -4 -17 13 -22 21 -14 21 2 0 10 -8 17 -17z m-503 -20 c-10 -2 -26 -2 -35 0 -10 3 -2 5 17 5 19 0 27 -2 18 -5z m0 -30 c-10 -2 -26 -2 -35 0 -10 3 -2 5 17 5 19 0 27 -2 18 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 244 c-19 -20 -32 -37 -30 -39 7 -7 74 -9 86 -1 18 11 15 63 -4 70 -19 7 -13 11 -52 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158 233 c18 -2 45 -2 60 0 15 2 0 4 -33 4 -33 0 -45 -2 -27 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 205 c-8 -6 -13 -20 -11 -31 3 -18 13 -19 198 -19 l195 0 3 28 c2 15 0 28 -5 28 -4 1 -88 2 -187 3 -116 1 -183 -2 -193 -9z m35 -23 c2 -7 -3 -12 -12 -12 -9 0 -16 7 -16 16 0 17 22 14 28 -4z m337 9 c7 -12 -12 -24 -25 -16 -11 7 -4 25 10 25 5 0 11 -4 15 -9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle11);
export default __webpack_public_path__ + "static/media/vehicle11.260508c7e59333d71bde0021b1d31117.svg";
export { ForwardRef as ReactComponent };